import React, { useState, useEffect, useRef, useCallback } from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';
import CancelIcon from '@material-ui/icons/Cancel';
import {
    Grid,
    Button,
    Box,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper
} from "@material-ui/core";
import ProviderService from "../../../../Services/ProviderService";
import AuthenticationService from "../../../../Services/AuthenticationService";
import { isNotEmpty, isEmpty } from "../../../../utils/Validator";
import LoadingMsgBar from "../../../LoadingMsgBar";
import GlobalMessage from "../../../GlobalMessage";
import "./Facility.css";
import FacilityLocationTbl from './FacilityLocationTbl';
import FacilityLicenseTbl from "./FacilityLicenseTbl";
import FacilityGeneralView from "./FacilityGeneralView"
import FacilityGeneralEdit from './FacilityGeneralEdit';
import FacilityLocationEdit from './FacilityLocationEdit';
import FacilityLicenseEdit from './FacilityLicenseEdit';


const Facility = (props) => {
    // State for facility data
    const [facility, setFacility] = useState(null);
    const [locations, setLocations] = useState([]);
    const [licenses, setLicenses] = useState([]);

    // State for filtered data display
    const [filterLocations, setfilterLocations] = useState([]);
    const [filterLicenses, setfilterLicenses] = useState([]);

    // UI state
    const [errormsg, setErrormsg] = useState('');
    const [loadMsg, setLoadMsg] = useState('Loading facility...');
    const [successMsg, setSuccessMsg] = useState('');
    const [isEditing, setIsEditing] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [hasChanges, setHasChanges] = useState(false);
    const [isMirror, setIsMirror] = useState(false);
    const [facilityType, setFacilityType] = useState('');

    // User permissions
    const [userPermissions, setUserPermissions] = useState({
        canEditDemographics: false
    });

    // Original data backup for cancel operation
    const [originalData, setOriginalData] = useState({
        facility: null,
        locations: [],
        licenses: []
    });

    // Section refs for form access
    const generalSectionRef = useRef(null);
    const locationSectionRef = useRef(null);
    const licenseSectionRef = useRef(null);



    // Edit state tracking
    const [sectionObjects, setSectionObjects] = useState({
        general: { pristine: null, modified: null },
        locations: { pristine: null, modified: null },
        licenses: { pristine: null, modified: null },

    });

    const [unsavedSections, setUnsavedSections] = useState({
        general: false,
        locations: false,
        licenses: false,

    });

    const [validatedSections, setValidatedSections] = useState({
        general: false,
        locations: true,
        licenses: true
    });

    const [participationTypes, setParticipationTypes] = useState([]);

    // Check user permissions
    const checkUserPermissions = useCallback(() => {
        let currentUser = AuthenticationService.getMirrorUser();
        if (isEmpty(currentUser)) {
            currentUser = AuthenticationService.getLoggedInUserName();
            setIsMirror(false);
        } else {
            setIsMirror(true);
        }

        if (currentUser) {
            AuthenticationService.getUsrDtls(currentUser)
                .then(response => {
                    if (response && response.data) {
                        const hasTypePermission = response.data.typeCd === 'PRAD' || response.data.typeCd === 'PRUS';
                        const hasFunctionPermission = Array.isArray(response.data.privilegedFunctions) &&
                            response.data.privilegedFunctions.includes('DMGMNT');

                        setUserPermissions({
                            canEditDemographics: hasTypePermission && hasFunctionPermission
                        });
                    }
                })
                .catch(error => {
                    console.error("Error fetching user details:", error);
                });
        }
    }, []);

    useEffect(() => {
        checkUserPermissions();
    }, [checkUserPermissions]);




    useEffect(() => {
        if (props.type) {
            setFacilityType(props.type);
        }
    }, [props.type]);

    // Data fetching functions
    const getProviderFacility = useCallback(() => {
        ProviderService.getProviderFacility(props.selectedPrvId)
            .then((response) => {
                if (isNotEmpty(response.data)) {
                    const facilityData = {
                        ...response.data,
                        prvParticipationType: 'A'
                    };
                    setFacility(facilityData);
                    if (response.data.participationList && Array.isArray(response.data.participationList)) {
                        //const types = response.data.participationList.map(item => item.parrShortDesc);
                        const types = response.data.participationList
                            .filter(item => item.statusFlag === "A")
                            .map(item => item.parrShortDesc);
                        setParticipationTypes(types);
                    }
                    setLoadMsg('');
                    getProviderFacilityLocations();
                } else {
                    setErrormsg('Error loading Facility data.');
                    setLoadMsg('');
                }
            }).catch((error) => {
                console.log('Error GETTING THE PROVIDER Facility' + error);
                setErrormsg('Error loading facility data.');
                setLoadMsg('');
            });
    }, [props.selectedPrvId]);

    const getProviderFacilityLocations = useCallback(() => {
        ProviderService.getProviderFacilityLocations(props.selectedPrvId)
            .then((response) => {
                setLoadMsg('');
                if (isNotEmpty(response.data)) {
                    setLocations(response.data);
                    setfilterLocations(response.data);
                }
                getProviderFacilityLicenses();
            }).catch((error) => {
                console.log('Error GETTING THE PROVIDER Facility locations' + error);
                setErrormsg(`Error loading facility locations: ${error}`);
                setLoadMsg('');
            });
    }, [props.selectedPrvId]);

    const getProviderFacilityLicenses = useCallback(() => {
        ProviderService.getFacilityLicenses(props.selectedPrvId)
            .then((response) => {
                setLoadMsg('');
                if (isNotEmpty(response.data)) {
                    setLicenses(response.data);
                    setfilterLicenses(response.data);
                }
            }).catch((error) => {
                console.log('Error GETTING THE PROVIDER Facility licenses' + error);
                setErrormsg('Error loading facility licenses data.');
                setLoadMsg('');
            });
    }, [props.selectedPrvId]);

    // Load data on component mount
    useEffect(() => {
        if (props.selectedPrvId) {
            getProviderFacility();
        }
    }, [props.selectedPrvId, getProviderFacility]);



    // Edit mode handlers
    const handleEditClick = () => {
        // Store original data as backup before entering edit mode
        setOriginalData({
            facility: { ...facility },
            locations: [...locations],
            licenses: [...licenses]
        });
        setSuccessMsg('');
        setIsEditing(true);
    };

    const handleLocationFilter = (filteredLocations) => {
        //console.log('Setting filtered locations:', filteredLocations);
        setfilterLocations(filteredLocations);
    };

    const updateLicenses = (updatedLicenses) => {
        setLicenses(updatedLicenses);
        setfilterLicenses(updatedLicenses);
    };

    const updateLocations = (updatedLocations) => {
        setLocations(updatedLocations);
        setfilterLocations(updatedLocations);
    };

    const handleLicenseSectionChanges = (action, licenseData, originalData = null) => {
        //console.log(`License ${action} detected:`, licenseData);

        if (action === 'batch') {
            // Handle batch changes
            setSectionObjects(prevState => ({
                ...prevState,
                licenses: {
                    pristine: prevState.licenses.pristine,
                    modified: licenseData // licenseData is an array of change records in this case
                }
            }));

            // Mark licenses section as having changes
            handleSectionHasChanges('licenses', true);
        } else {
            // Handle individual changes (add, edit, delete)
            setSectionObjects(prevState => {
                const currentLicenseChanges = prevState.licenses.modified || [];

                // Create a change record
                const licenseId = licenseData?.prvId || (originalData?.prvId || 'unknown');
                const changeRecord = {
                    action: action,
                    licenseId: licenseId,
                    newData: action !== 'delete' ? licenseData : null,
                    oldData: action === 'edit' || action === 'delete' ? originalData : null,
                    timestamp: new Date().getTime()
                };

                // Remove any previous actions on the same license
                const filteredChanges = Array.isArray(currentLicenseChanges)
                    ? currentLicenseChanges.filter(change => change.licenseId !== licenseId)
                    : [];

                return {
                    ...prevState,
                    licenses: {
                        pristine: prevState.licenses.pristine,
                        modified: [...filteredChanges, changeRecord]
                    }
                };
            });

            // Mark licenses section as having changes
            handleSectionHasChanges('licenses', true);
        }
    };

    const handleChange = (field, value) => {
        console.log(`Field change: ${field} = ${value}`);

        // Only update facility state if we're in edit mode
        if (isEditing) {
            setFacility(prev => ({
                ...prev,
                [field]: value
            }));
        } else {
            console.log("Ignoring change because not in edit mode");
        }
    };

    const handleCancelEdit = () => {
        // Restore data from backup and reset state
        setFacility(originalData.facility);
        setLocations(originalData.locations);
        setfilterLocations(originalData.locations);
        setLicenses(originalData.licenses);
        setfilterLicenses(originalData.licenses);

        // Reset UI state
        setIsEditing(false);
        setHasChanges(false);
        setErrormsg('');

        // Reset all section states
        setUnsavedSections({
            general: false,
            locations: false,
            licenses: false,

        });


        setValidatedSections({
            general: false,
            locations: true,
            licenses: true
        });

        setSectionObjects({
            general: { pristine: null, modified: null },
            locations: { pristine: null, modified: null },
            licenses: { pristine: null, modified: null }
        });
    };

    // Section change handlers
    const handleSectionSaveLocal = (sectionName, objects) => {
        // Update the section objects state
        setSectionObjects(prev => ({
            ...prev,
            [sectionName]: {
                pristine: objects.pristineObject,
                modified: objects.modifiedObject
            }
        }));

        // Mark this section as saved and validated
        setUnsavedSections(prev => ({
            ...prev,
            [sectionName]: false
        }));

        setValidatedSections(prev => ({
            ...prev,
            [sectionName]: objects.isValid || false
        }));

        // Always set hasChanges to true if we have modified objects
        if (objects.modifiedObject) {
            setHasChanges(true);
        }
    };

    const handleSectionDiscardChanges = (sectionName, objects) => {
        console.log(`Discarding changes for section: ${sectionName}`, objects);

        // If this is the general section, update the facility state with original values
        if (sectionName === 'general' && objects.pristineObject) {
            console.log("Resetting facility state to pristine object:", objects.pristineObject);
            setFacility(prev => ({
                ...prev,
                prvNpi: objects.pristineObject.prvNpi,
                altNpiList: objects.pristineObject.altNpiList || []
            }));
        }

        // Update the section objects state
        setSectionObjects(prev => ({
            ...prev,
            [sectionName]: {
                pristine: objects.pristineObject,
                modified: null
            }
        }));

        // Mark section as not having unsaved changes
        setUnsavedSections(prev => ({
            ...prev,
            [sectionName]: false
        }));

        // Reset validation status for this section
        setValidatedSections(prev => ({
            ...prev,
            [sectionName]: sectionName !== 'general'
        }));

        // Check if there are any remaining changes in other sections
        const remainingChanges = Object.keys(sectionObjects)
            .filter(key => key !== sectionName)
            .some(key => sectionObjects[key].modified !== null);

        // Update hasChanges flag
        setHasChanges(remainingChanges);
    };

    const handleSectionHasChanges = (sectionName, hasUnsavedChanges) => {
        console.log(`Section ${sectionName} has changes: ${hasUnsavedChanges}`);
        console.log("Current unsavedSections:", unsavedSections);
        console.log("Current hasChanges:", hasChanges);

        // Update unsaved sections state
        setUnsavedSections(prev => {
            console.log("Previous unsavedSections:", prev);
            return {
                ...prev,
                [sectionName]: hasUnsavedChanges
            };
        });

        // If a section has new changes, it needs validation again (for general section)
        if (hasUnsavedChanges && sectionName === 'general') {
            setValidatedSections(prev => ({
                ...prev,
                [sectionName]: false
            }));
        }

        // Also update the global hasChanges state if any section has changes
        if (hasUnsavedChanges) {
            console.log("Setting global hasChanges to true");
            setHasChanges(true);
        } else {
            // Check if any other section has changes
            const anyOtherSectionHasChanges = Object.keys(unsavedSections)
                .filter(key => key !== sectionName)
                .some(key => unsavedSections[key]);

            console.log("Any other section has changes:", anyOtherSectionHasChanges);
            setHasChanges(anyOtherSectionHasChanges);
        }
    };

    const formatLocationObject = (location) => {
        // Extract focus information from the details array
        const focus = location.details && Array.isArray(location.details) && location.details.length > 0
            ? location.details.map(detail => detail.focusName || detail.focusShortDesc || detail.value || '')
            : [];

        // Extract address components - parse if not available
        let addressComponents = location.addressComponents;

        if (!addressComponents) {
            // Parse from addressString if components don't exist
            addressComponents = parseAddressString(location.addressString || location.address || '');
        }

        // Extract services
        const services = location.services && location.services.length > 0
            ? location.services.map(service =>
                typeof service === 'string' ? service : (service.serviceDesc || service.fsrShortDesc || "")
            )
            : [];

        // Extract specialties
        const specialties = location.specialties && location.specialties.length > 0
            ? location.specialties.map(specialty =>
                typeof specialty === 'string' ? specialty : (specialty.specialtyDesc || specialty.specDesc || "")
            )
            : [];



        // Extract languages
        const languages = location.languages && location.languages.length > 0
            ? location.languages.map(language =>
                typeof language === 'string' ? language : (language.languageDesc || language.lngLanguageName || "")
            )
            : [];

        const formatAcceptingWcPatients = (flag) => {
            if (flag === 'Y') return 'YES';
            if (flag === 'N') return 'NO';
            if (!flag || flag.trim() === '') return 'Not Set';
            return flag; // Return as-is if it's already formatted (YES/NO)
        };

        return {
            name: location.faclocDirectoryLocName || "",
            practiceTIN: location.ptcTaxId || "",
            addressLine1: addressComponents.address1 || "",
            addressLine2: addressComponents.address2 || "",
            city: addressComponents.city || "",
            state: addressComponents.state || "",
            zipCode: addressComponents.zip || "",
            zipPlusFour: addressComponents.zipExt || "",
            county: addressComponents.county || "",
            phone: location.faclocDirectoryPhoneNbr || "",
            fax: location.faclocFaxNbr || "",
            email: location.faclocEmailAddress || "",
            acceptingNewWcPatients: formatAcceptingWcPatients(location.flfAcceptWcPatients),
            acceptingNewWcPatientsDate: location.flfAcceptWcPatDate
                ? new Date(location.flfAcceptWcPatDate).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit'
                })
                : null,
            focuses: focus || location.details,
            services: services,
            specialties: specialties,
            languages: languages
        };
    };

    // Helper function to parse address string
    const parseAddressString = (addressString) => {
        const components = {
            address1: '',
            address2: '',
            city: '',
            state: '',
            county: '',
            zip: '',
            zipExt: ''
        };

        if (!addressString || addressString.trim() === '') {
            return components;
        }

        try {
            // Example: "10 Gove St, EAST BOSTON, MA, 02128 - 1920, Suffolk"
            // Split by comma
            const parts = addressString.split(',').map(part => part.trim());

            if (parts.length >= 1) {
                // First part is address line 1
                // Handle case where address line might have newline
                const addressLines = parts[0].split('\n').map(line => line.trim());
                components.address1 = addressLines[0] || '';
                components.address2 = addressLines.length > 1 ? addressLines[1] : '';
            }

            if (parts.length >= 2) {
                // Second part is city
                components.city = parts[1] || '';
            }

            if (parts.length >= 3) {
                // Third part is state
                components.state = parts[2].trim() || '';
            }

            if (parts.length >= 4) {
                // Fourth part contains zip and zip extension
                // Format: "02128 - 1920" or "02128-1920"
                const zipPart = parts[3].trim();

                // Extract zip code (5 digits)
                const zipMatch = zipPart.match(/(\d{5})/);
                if (zipMatch) {
                    components.zip = zipMatch[1];
                }

                // Extract zip extension (4 digits after dash or space)
                const zipExtMatch = zipPart.match(/[-\s](\d{4})/);
                if (zipExtMatch) {
                    components.zipExt = zipExtMatch[1];
                }
            }

            if (parts.length >= 5) {
                // Fifth part is county (last)
                components.county = parts[4].trim() || '';
            }

        } catch (error) {
            console.warn('Error parsing address string:', error, addressString);
        }

        return components;
    };
    const formatLicenseObject = (license) => {
        // Helper function to format dates without timezone issues, similar to parseDateString in PhysicianLicenseEdit
        const formatDateToYYYYMMDD = (dateString) => {
            if (!dateString) return null;

            // Handle different date formats
            let parts;

            // If it's already in YYYY-MM-DD format
            if (dateString.includes('-')) {
                return dateString; // Already in the correct format, don't process further
            }

            // If it's in MM/DD/YYYY format
            if (dateString.includes('/')) {
                parts = dateString.split('/');
                if (parts.length === 3) {
                    // Convert MM/DD/YYYY to YYYY-MM-DD
                    const month = parts[0].padStart(2, '0');
                    const day = parts[1].padStart(2, '0');
                    const year = parts[2];
                    return `${year}-${month}-${day}`;
                }
            }

            // If we can't parse it in a known format, try using Date but avoid timezone issues
            try {
                // Create date object and extract components directly without timezone conversion
                const date = new Date(dateString);
                if (isNaN(date.getTime())) return null;

                // Use local date components and manually format to YYYY-MM-DD
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');

                return `${year}-${month}-${day}`;
            } catch (e) {
                console.error("Error parsing date:", e);
                return null;
            }
        };

        return {
            licenseType: license.ltrLicenseType || "",
            state: license.plicStateCode || "",
            licenseNumber: license.plicLicenseNbr || "",
            issueDate: formatDateToYYYYMMDD(license.plicIssueDate),
            expirationDate: formatDateToYYYYMMDD(license.plicExpirationDate),
            status: license.lsrStatus || ""
        };
    };
    const standardizeAcceptingPatientsFormat = (value) => {
        if (!value) return '';

        // Convert Y/N format to YES/NO
        if ((value === 'Y') || (value === 'YES') || (value === 'Yes')) return 'Yes';
        if ((value === 'N') || (value === 'NO') || (value === 'N')) return 'No';
        return value; // Return original if no match
    };
    // Save all changes
    const saveAllChanges = () => {
        // First validate all sections
        setLoadMsg('Validating changes...');
        setErrormsg('');

        // Get form data from all sections
        const generalData = generalSectionRef.current?.getFormData() || {};
        const locationData = locationSectionRef.current?.getFormData?.() || {};
        const licenseData = licenseSectionRef.current?.getFormData?.() || {};



        // Validate each section
        let generalValid = true;
        if (generalData.modifiedObject) {
            if (generalSectionRef.current?.validateForm) {
                generalValid = generalSectionRef.current.validateForm();
            }

        }

        let locationValid = true;
        if (locationSectionRef.current?.validateForm) {
            locationValid = locationSectionRef.current.validateForm() || true;
        }

        let licenseValid = true;
        if (licenseSectionRef.current?.validateForm) {
            licenseValid = licenseSectionRef.current.validateForm() || true;
        }

        // Check if all sections are valid
        if (!generalValid || !locationValid || !licenseValid) {
            setErrormsg('Please fix validation errors before saving');
            setLoadMsg('');
            setTimeout(() => setErrormsg(''), 5000);
            return;
        }

        // Check if there are any changes to save
        const hasAnyChanges = generalData.modifiedObject ||
            locationData.modifiedObject ||
            licenseData.modifiedObject;


        if (!hasAnyChanges) {
            setErrormsg(`No changes detected. Update the facility's demographic information or click 'CANCEL' to return.`);
            setLoadMsg('');
            window.scrollTo(0, 0);
            return;
        }

        setIsSaving(true);
        setLoadMsg('Saving changes...');

        // Create the provider identification info
        const providerIdentificationInfo = {
            providerId: props.selectedPrvId,
            providerName: facility?.faclFacilityName || "",
            providerType: facilityType === 'H' ? 'Hospital' : facilityType === 'A' ? 'Ancillary' : 'Facility',
            primaryTIN: facility?.faclTaxId || "",
            npi: facility?.prvNpi || ""
        };

        // Create individual objects for each change type
        let generalInfoChange = null;
        let locationChanges = null;
        let licenseChanges = null;

        // Populate general info changes if they exist
        if (generalData?.modifiedObject) {
            const originalAltNpis = generalData.pristineObject?.altNpiList || [];
            const modifiedAltNpis = generalData.modifiedObject?.altNpiList || [];
            const nameKey = facilityType === 'H' ? 'hospitalName' : facilityType === 'A' ? 'facilityName' : 'facilityName';
            generalInfoChange = {
                action: "MODIFY",
                before: {
                    [nameKey]: generalData.pristineObject?.faclFacilityName || "",
                    tin: generalData.pristineObject?.faclTaxId || "",
                    npi: generalData.pristineObject?.prvNpi || "",
                    lob: generalData.pristineObject?.fLob || "",
                    altNpis: originalAltNpis.map(npi => npi.panpiNpi)
                },
                after: {
                    [nameKey]: generalData.modifiedObject?.faclFacilityName || "",
                    tin: generalData.modifiedObject?.faclTaxId || "",
                    npi: generalData.modifiedObject?.prvNpi || "",
                    lob: generalData.modifiedObject?.fLob || "",
                    altNpis: modifiedAltNpis.map(npi => npi.panpiNpi)
                }
            };
        }

        // Format and populate location changes
        if (locationData?.modifiedObject) {
            locationChanges = [];

            // Handle the structure with active array and changes object
            if (locationData.modifiedObject.changes) {
                if (locationData.modifiedObject.changes.newLocations?.length > 0) {
                    locationData.modifiedObject.changes.newLocations.forEach(location => {
                        console.log("Adding new location:", location);
                        const formattedLocation = formatLocationObject(location);
                        locationChanges.push({
                            action: "ADD",
                            after: {
                                ...formattedLocation,
                                locationId: ""  // Empty for new locations
                            }
                        });
                    });
                }

                if (locationData.modifiedObject.changes.modifiedLocations?.length > 0) {
                    locationData.modifiedObject.changes.modifiedLocations.forEach(change => {
                        console.log("Modifying location:", change);

                        const originalWithDefaults = {
                            ...change.original,
                            details: change.original.details || [],
                            focuses: change.original.focuses || [],
                            services: change.original.services || [],
                            specialties: change.original.specialties || [],
                            languages: change.original.languages || []
                        };

                        const modifiedWithDefaults = {
                            ...change.modified,
                            details: change.modified.details || [],
                            focuses: change.modified.focuses || [],
                            services: change.modified.services || [],
                            specialties: change.modified.specialties || [],
                            languages: change.modified.languages || []
                        };

                        const formattedBefore = formatLocationObject(originalWithDefaults);
                        const formattedAfter = formatLocationObject(modifiedWithDefaults);

                        locationChanges.push({
                            action: "MODIFY",
                            before: {
                                ...formattedBefore,
                                locationId: change.original.flfFaclocId || ""
                            },
                            after: {
                                ...formattedAfter,
                                locationId: change.modified.flfFaclocId || change.original.flfFaclocId
                            }
                        });
                    });
                }

                if (locationData.modifiedObject.changes.deletedLocations?.length > 0) {
                    locationData.modifiedObject.changes.deletedLocations.forEach(location => {
                        console.log("Deleting location:", location);

                        // FIXED: Ensure deleted location has proper focus data
                        const locationWithDefaults = {
                            ...location,
                            details: location.details || [],
                            focuses: location.focuses || [],
                            services: location.services || [],
                            specialties: location.specialties || [],
                            languages: location.languages || []
                        };

                        const formattedLocation = formatLocationObject(locationWithDefaults);

                        locationChanges.push({
                            action: "REMOVE",
                            before: {
                                ...formattedLocation,
                                locationId: location.flfFaclocId
                            }
                        });
                    });
                }
            }

            // If no changes were found, set locationChanges to null
            if (locationChanges.length === 0) {
                locationChanges = null;
            }

            console.log("Final locationChanges:", locationChanges);
        }
        // Format and populate license changes
        if (licenseData?.modifiedObject) {
            licenseChanges = [];
            // Handle new locations (ADD)
            if (licenseData.modifiedObject.changes.newLicenses?.length > 0) {
                licenseData.modifiedObject.changes.newLicenses.forEach(license => {
                    licenseChanges.push({
                        action: "ADD",
                        after: formatLicenseObject(license)
                    });
                });
            }

            // Handle modified locations (MODIFY)
            if (licenseData.modifiedObject.changes.modifiedLicenses?.length > 0) {
                licenseData.modifiedObject.changes.modifiedLicenses.forEach(change => {
                    licenseChanges.push({
                        action: "MODIFY",
                        before: formatLicenseObject(change.original),
                        after: formatLicenseObject(change.modified)
                    });
                });
            }


            // Handle deleted locations (REMOVE)
            if (licenseData.modifiedObject.changes.deletedLicenses?.length > 0) {
                licenseData.modifiedObject.changes.deletedLicenses.forEach(license => {
                    licenseChanges.push({
                        action: "REMOVE",
                        before: formatLicenseObject(license)
                    });
                });
            }



            // If no changes were found, set locationChanges to null
            if (licenseChanges.length === 0) {
                licenseChanges = null;
            }
        }

        // Create the request object with only populated properties
        const requestObject = {
            providerIdentificationInfo
        };

        // Add each change type only if it exists
        if (generalInfoChange) requestObject.generalInfoChange = generalInfoChange;
        if (locationChanges) requestObject.locationChanges = locationChanges;
        if (licenseChanges) requestObject.licenseChanges = licenseChanges;


        console.log("Facility info change request:", requestObject);

        // Call the provider info change service
        ProviderService.submitFacilityInfoChange(requestObject)
            .then((response) => {
                // Handle the response from the provider info change service
                if (response.status === 200 || response.status === 201) {
                    // Refresh data
                    setLocations([]);
                    setfilterLocations([]);
                    setLicenses([]);
                    setfilterLicenses([]);

                    getProviderFacility();

                    // Reset component state
                    setIsEditing(false);
                    setHasChanges(false);
                    setLoadMsg('');

                    // Reset all section states
                    setUnsavedSections({
                        general: false,
                        locations: false,
                        licenses: false
                    });

                    setValidatedSections({
                        general: false,
                        locations: true,
                        licenses: true
                    });

                    setSectionObjects({
                        general: { pristine: null, modified: null },
                        locations: { pristine: null, modified: null },
                        licenses: { pristine: null, modified: null }
                    });

                    setSuccessMsg('Facility demographics changes submitted successfully. You will receive an email with your assigned case number.');
                    window.scrollTo(0, 0);
                } else {
                    throw new Error('Service returned an error status');
                }
            })
            .catch((error) => {
                console.error('Error saving changes:', error);
                setErrormsg('Error: An error has occurred. Please try again or contact Customer Service.');
                setLoadMsg('');
                window.scrollTo(0, 0);
            })
            .finally(() => {
                setIsSaving(false);
            });
    };

    // Render the component
    return (
        <div className='App-content'>
            <LoadingMsgBar loadMsg={loadMsg} />
            <GlobalMessage message={errormsg} />
            <GlobalMessage type='success' message={successMsg} />

            {facility ? (
                <div>
                    <Grid
                        container
                        justifyContent="space-between"
                        style={{ width: "100%" }}
                    >
                        <Grid item style={{ width: "50%" }} justifyContent="left">
                            <h1 className='App-page-label'>
                                {`${facilityType === 'H' ? 'Hospital' : facilityType === 'A' ? 'Ancillary' : 'Facility'} - ${facility.faclFacilityName}`}
                            </h1>
                        </Grid>
                        <Grid item style={{ width: "50%" }} justifyContent="right">
                            <Button
                                variant="outlined"
                                onClick={props.back}
                                style={{ float: 'right' }}
                                aria-label='PROVIDER DEMOGRAPHICS: BACK TO DEMOGRAPHICS SEARCH Button'
                                disabled={isEditing && isSaving}
                            >
                                Back to Demographic Search
                            </Button>
                        </Grid>
                    </Grid>


                    <Accordion defaultExpanded>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Grid container justifyContent="space-between" alignItems="center" style={{ width: "100%" }}>
                                <h5>General Information</h5>
                                {isEditing && unsavedSections.general && (
                                    <span style={{ color: '#f57c00', marginRight: '16px' }}>
                                        Unsaved Changes
                                    </span>
                                )}
                            </Grid>
                        </AccordionSummary>
                        <AccordionDetails>
                            {isEditing ? (
                                <FacilityGeneralEdit
                                    facility={facility} onChange={handleChange} facilityType={facilityType}
                                    ref={generalSectionRef}
                                    onSectionSaveLocal={objects => handleSectionSaveLocal("general", objects)}
                                    onSectionDiscardChanges={objects => handleSectionDiscardChanges("general", objects)}
                                    onSectionHasChanges={hasChanges => handleSectionHasChanges("general", hasChanges)}
                                />
                            ) : (
                                <FacilityGeneralView facility={facility} facilityType={facilityType} />)}
                        </AccordionDetails>
                    </Accordion>

                    {/* Locations Section */}
                    <Accordion defaultExpanded={isEditing}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel3a-content"
                            id="panel3a-header"
                        >
                            <Grid container justifyContent="space-between" alignItems="center" style={{ width: "100%" }}>
                                <h5>Locations</h5>
                                {isEditing && unsavedSections.locations && (
                                    <span style={{ color: '#f57c00', marginRight: '16px' }}>
                                        Unsaved Changes
                                    </span>
                                )}
                            </Grid>
                        </AccordionSummary>
                        <AccordionDetails style={{ width: '100%', padding: '8px 16px' }}>
                            {isEditing ? (
                                <FacilityLocationEdit style={{ width: '100%' }}
                                    locations={locations} type={facilityType} prvId={props.selectedPrvId}
                                    ptcTaxId={facility.faclTaxId} participationTypes={participationTypes}
                                    setFilter={handleLocationFilter}
                                    filtered={filterLocations}
                                    updateLocations={updateLocations}
                                    onSectionSaveLocal={objects => handleSectionSaveLocal("locations", objects)}
                                    onSectionDiscardChanges={objects => handleSectionDiscardChanges("locations", objects)}
                                    onSectionHasChanges={hasChanges => handleSectionHasChanges("locations", hasChanges)}
                                    ref={locationSectionRef}
                                />

                            ) : (
                                locations.length > 0 ? (
                                    <FacilityLocationTbl type={facilityType} style={{ width: '100%' }}
                                        locations={filterLocations}
                                        setFilter={setfilterLocations}
                                        filtered={locations}
                                    />
                                ) : (
                                    <span>No locations found</span>
                                )
                            )}
                        </AccordionDetails>
                    </Accordion>

                    {/* Licenses Section */}
                    <Accordion defaultExpanded={isEditing}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel4a-content"
                            id="panel4a-header"
                        >
                            <Grid container justifyContent="space-between" alignItems="center" style={{ width: "100%" }}>
                                <h5>Licenses</h5>
                                {isEditing && unsavedSections.licenses && (
                                    <span style={{ color: '#f57c00', marginRight: '16px' }}>
                                        Unsaved Changes
                                    </span>
                                )}
                            </Grid>
                        </AccordionSummary>
                        <AccordionDetails>
                            {isEditing ? (

                                <FacilityLicenseEdit
                                    licenses={filterLicenses} type={facilityType}
                                    filtered={licenses}
                                    setFilter={setfilterLicenses}
                                    updateLicenses={updateLicenses}
                                    onChange={handleLicenseSectionChanges}
                                    onSectionSaveLocal={objects => handleSectionSaveLocal("licenses", objects)}
                                    onSectionDiscardChanges={objects => handleSectionDiscardChanges("licenses", objects)}
                                    onSectionHasChanges={hasChanges => handleSectionHasChanges("licenses", hasChanges)}
                                    ref={licenseSectionRef}
                                />
                            ) : (
                                licenses.length > 0 ? (
                                    <FacilityLicenseTbl style={{ width: '100%' }}
                                        licenses={filterLicenses}
                                        filtered={licenses}
                                        setFilter={setfilterLicenses}
                                    />
                                ) : (
                                    <span>No licenses found</span>
                                )
                            )}
                        </AccordionDetails>
                    </Accordion>


                    {/* Action Buttons */}
                    <Grid
                        container
                        justifyContent="space-between"
                        style={{ width: "100%", marginTop: "20px" }}
                    >
                        <Grid item style={{ width: "50%" }} justifyContent="left">
                            {isEditing ? (
                                <Box display="flex" gap={2}>
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        onClick={handleCancelEdit}
                                        startIcon={<CancelIcon />}
                                        disabled={isSaving}
                                        aria-label="Cancel editing"
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={saveAllChanges}
                                        startIcon={<SaveIcon />}
                                        disabled={isSaving || isMirror}
                                        aria-label="Save all changes"
                                    >
                                        SUBMIT All CHANGES
                                    </Button>
                                </Box>
                            ) : (
                                userPermissions.canEditDemographics && (
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleEditClick}
                                        startIcon={<EditIcon />}
                                        aria-label="Edit facility demographics"
                                    >
                                        Edit Demographics
                                    </Button>
                                )
                            )}
                        </Grid>
                        <Grid item style={{ width: "50%" }} justifyContent="right">
                            <Button
                                variant="outlined"
                                onClick={props.back}
                                style={{ float: 'right' }}
                                aria-label='PROVIDER DEMOGRAPHICS: BACK TO DEMOGRAPHICS SEARCH Button'
                                disabled={isEditing && isSaving}
                            >
                                Back to Demographic Search
                            </Button>
                        </Grid>
                    </Grid>
                </div>
            ) : (
                <div>Loading facility data...</div>
            )}
        </div>
    );
};

export default Facility;